"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractGetByIdGrouped = exports.AbstractGroupedGet = exports.BATCH_TIMEOUT = exports.BATCH_MAX_SIZE = void 0;
const interfaces_1 = require("@build-5/interfaces");
const lodash_1 = require("lodash");
exports.BATCH_MAX_SIZE = 100;
exports.BATCH_TIMEOUT = 500;
class AbstractGroupedGet {
    constructor() {
        this.requests = [];
        this.timer = null;
        this.toKey = (r) => r.dataset + r.setId + r.subset + r.subsetId;
        this.init = (request) => {
            const existing = this.requests.find((r) => this.toKey(r) === this.toKey(request));
            if (!existing) {
                this.requests.push(request);
            }
        };
        this.executeTimed = async () => {
            if (!this.timer) {
                this.timer = new Promise((resolve) => setTimeout(async () => {
                    await this.executeRequests();
                    resolve();
                }, exports.BATCH_TIMEOUT));
            }
            await this.timer;
            this.timer = null;
        };
        this.groupRequests = () => {
            const requests = this.requests.splice(0);
            const remainin = [];
            const result = requests.reduce((acc, act) => {
                const key = act.origin + act.apiKey + act.dataset + act.subset;
                const current = acc[key] || [];
                if (current.length < exports.BATCH_MAX_SIZE) {
                    current.push(act);
                }
                return Object.assign(Object.assign({}, acc), { [key]: current });
            }, {});
            this.requests.push(...remainin);
            return result;
        };
        this.createUrl = () => {
            throw new Error('Method not implemented.');
        };
        this.executeRequests = async () => {
            throw new Error('Method not implemented.');
        };
    }
}
exports.AbstractGroupedGet = AbstractGroupedGet;
class AbstractGetByIdGrouped extends AbstractGroupedGet {
    constructor() {
        super(...arguments);
        this.createUrl = () => Object.values(this.groupRequests()).map((r) => {
            const params = {
                dataset: r[0].dataset,
                setIds: r.map((r) => r.setId),
            };
            if (r[0].subset) {
                const subsetIds = r.map((r) => r.subsetId);
                (0, lodash_1.set)(params, 'subsetIds', subsetIds);
                (0, lodash_1.set)(params, 'subset', r[0].subset);
            }
            const url = r[0].origin + interfaces_1.ApiRoutes.GET_MANY_BY_ID;
            return { requests: r, url, params };
        });
    }
}
exports.AbstractGetByIdGrouped = AbstractGetByIdGrouped;
